import './GalleryNav.scss';
class GalleryNav {
    constructor( node ) {
        this.node = node;
        this.initScroll = false;
    }
    init() {
        let t = this;
        let items = t.node.querySelectorAll('.item__link[data-id]');
        let observer = new IntersectionObserver(
            ( entries, index ) => {
                entries.forEach( ( entry, index ) => {

                    if( entry.isIntersecting ) {
                        items.forEach( ( link, index ) => {
                            if( entry.target.getAttribute('id') != link.getAttribute('data-id') ) {
                                link.classList.remove('active');
                            } else {
                                link.classList.add('active');
                                if( t.node.classList.contains('GalleryNav__view--mobile') && t.initScroll ) {
                                    t.node.scrollTo({ 
                                        left: link.closest('.GalleryNav__item').offsetLeft,
                                        behavior: 'smooth' 
                                    });
                                }
                            }
                        }); 
                    }

                });
            },
            {
                threshold : 0,
                rootMargin : '-50% 0px -50% 0px'
            }
        );
        items.forEach( ( link, index ) => {
            if( document.getElementById( link.getAttribute('data-id') ) ) {
                observer.observe( document.getElementById( link.getAttribute('data-id') ) );
            }
        });
        if( t.node.classList.contains('GalleryNav__view--mobile') ) {
            setTimeout( () => {
                if( t.node.querySelector('.item__link.active[data-id]') ) {
                    t.node.scrollTo({ 
                        left: t.node.querySelector('.item__link.active[data-id]').offsetLeft,
                        behavior: 'smooth' 
                    });
                    t.initScroll = true;
                }
            }, 300 );
        }
    }
}
JSModules['GalleryNav'] = GalleryNav;
export default GalleryNav;